import { motion, useReducedMotion } from 'framer-motion';
import { Activity, ShieldCheck } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { googleLoginUrl } from '../lib/api';
import { fadeOnly, fadeRise } from '../lib/motion';

const ERRORS: Record<string, string> = {
  oauth_state: 'Sesi login kedaluwarsa. Silakan coba lagi.',
  oauth_exchange: 'Gagal memverifikasi akun Google. Coba lagi.',
  email_unverified: 'Email Google Anda belum terverifikasi.',
};

export function Login() {
  const reduce = useReducedMotion();
  const variants = reduce ? fadeOnly : fadeRise;
  const [params] = useSearchParams();
  const error = params.get('error');

  return (
    <div className="flex h-full items-center justify-center p-[18px]">
      <div className="flex h-full w-full overflow-hidden rounded-3xl shadow-soft">
        {/* Brand panel (gradient — exception #5, approved) */}
        <div className="hidden w-1/2 flex-col justify-between bg-gradient-to-br from-blue-700 via-blue-600 to-sky-400 p-12 text-white md:flex">
          <div className="flex items-center gap-2">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-white/15">
              <Activity size={22} aria-hidden />
            </span>
            <span className="font-display text-xl font-extrabold">Klinik Bisnis</span>
          </div>
          <motion.div initial="hidden" animate="show" variants={variants}>
            <h1 className="font-display text-4xl font-extrabold leading-tight">
              Diagnosa dulu,
              <br />
              baru obat.
            </h1>
            <p className="mt-4 max-w-sm text-white/85">
              General Check-Up bisnis yang terstruktur &amp; terukur — temukan masalah, kekuatan,
              peluang &amp; ancaman perusahaan Anda.
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {['SWOT', 'Keuangan', 'Operasional', 'Pemasaran'].map((t) => (
                <span key={t} className="rounded-full bg-white/15 px-3 py-1 text-xs font-semibold">
                  {t}
                </span>
              ))}
            </div>
          </motion.div>
          <div className="text-xs text-white/70">
            make Ur&apos; business more healthy, growing and blessed
          </div>
        </div>

        {/* Login panel */}
        <div className="flex w-full items-center justify-center bg-white p-12 md:w-1/2">
          <motion.div className="w-full max-w-sm" initial="hidden" animate="show" variants={variants}>
            <div className="font-display text-2xl font-bold text-slate-900">Masuk ke akun Anda</div>
            <p className="mt-1.5 text-sm text-slate-500">
              Khusus untuk Owner &amp; tim Nine Co. Gunakan akun Google perusahaan.
            </p>

            {error && (
              <div className="mt-4 rounded-xl bg-red-50 p-3 text-sm text-red-700">
                {ERRORS[error] ?? 'Terjadi kesalahan saat login.'}
              </div>
            )}

            <a
              href={googleLoginUrl()}
              className="mt-7 flex w-full items-center justify-center gap-3 rounded-xl border border-slate-200 bg-white py-3.5 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
            >
              <GoogleMark />
              Lanjutkan dengan Google
            </a>

            <div className="mt-5 flex gap-2 rounded-xl bg-blue-50 p-3.5 text-xs text-blue-800">
              <ShieldCheck size={16} className="mt-0.5 shrink-0" aria-hidden />
              <div>
                <div className="font-semibold">PIC divisi tidak perlu login.</div>
                Owner mengundang PIC; mereka mengisi kuesioner lewat tautan aman yang dikirim via
                email &amp; WhatsApp.
              </div>
            </div>
            <p className="mt-6 text-center text-[11px] text-slate-400">
              Dengan masuk, Anda menyetujui Kebijakan Privasi (UU PDP) Klinik Bisnis.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

function GoogleMark() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="#4285F4"
        d="M21.35 11.1h-9.18v2.92h5.27c-.23 1.4-1.6 4.1-5.27 4.1-3.17 0-5.76-2.62-5.76-5.85s2.59-5.85 5.76-5.85c1.8 0 3.02.77 3.71 1.43l2.53-2.44C16.99 3.5 14.86 2.6 12.17 2.6 6.97 2.6 2.75 6.82 2.75 12s4.22 9.4 9.42 9.4c5.44 0 9.04-3.82 9.04-9.2 0-.62-.07-1.1-.16-1.1z"
      />
    </svg>
  );
}
